import dayjs from 'dayjs';

import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import DateInput from 'components/field/DateInput';
import IntegerInput from 'components/field/IntegerInput';
import FormItem from 'components/form/FormItem';

import * as S from '../OTOLink.styled';

const defaultColSpan = {
	md: 6
};
const LinkDetails = ({ mode }) => {
	const isViewMode = mode === 'view';
	const isEditMode = mode === 'edit';
	const linkExpiryRef = useRef(null);
	const {
		watch,
		setValue,
		formState: { isSubmitting, isLoading: isFormLoading, errors }
	} = useFormContext();

	useEffect(() => {
		if (errors?.linkExpiryCount) {
			linkExpiryRef?.current?.open?.();
		}
	}, [errors?.linkExpiryCount, linkExpiryRef]);

	const isLoading = isSubmitting || isFormLoading;

	return (
		<S.FlexAccordion ref={linkExpiryRef} header="otoLinkExpiryDetails" defaultVisible>
			{!isEditMode && (
				<FormItem label="linkExpiryCount" colSpan={defaultColSpan} required isLoading={isLoading}>
					<IntegerInput
						name="linkExpiryCount"
						placeholder="otoLinkExpiryCountPlaceholder"
						disabled={isViewMode || isEditMode}
					/>
				</FormItem>
			)}
			<FormItem label="expiryDate" colSpan={!isEditMode && defaultColSpan} isLoading={isLoading}>
				<DateInput
					placeholder="otoLinkExpiryDatePlaceholder"
					name="linkExpiryDate"
					value={watch('linkExpiryDate')}
					setValue={(value) => {
						setValue('linkExpiryDate', value || null, { shouldValidate: true, shouldDirty: true });
					}}
					minDate={dayjs().startOf('day').toISOString()}
					disabled={isViewMode}
				/>
			</FormItem>
		</S.FlexAccordion>
	);
};

export default LinkDetails;
